import React, {useRef, useState} from "react"
import {useParams} from "react-router"
import Title from '@base/Title'
import Toast from '@base/Toast'
import {ProcessoResolver} from "@helpers/ProcessoHelper"
import CartoesTableView from "@pages/Escola/Cartoes/componentes/CartoesTableView"
import QuantitativoTratamentoDataNascimento from "@pages/TratamentoDataNascimento/QuantitativoTratamentoDataNascimento";

export const DashboardTratamentoDataNacimento = () => {
  const toastRef = useRef(null);
  const params = useParams();
  const processo = ProcessoResolver(params.processo);
  const [statusSelecionado, setStatusSelecionado] = useState();
  const [tipoSelecionado, setTipoSelecionado] = useState();
  const [horaUltimoRefresh, setHoraUltimoRefresh] = useState();

  const limparFiltros = () => {
    setStatusSelecionado("");
    setTipoSelecionado("");
  }


  const columns = [
    {label: 'id', name: 'id', hidden: true, key: true},
    {
      label: 'Origem do Cartão',
      name: 'origem',
      filter: 'objetoPostal.origem',
      func: (objColuna, objLinha) => objColuna ? objColuna.descricao : "",
      key: false
    },
    {label: 'Código', name: 'codigo', key: false},
    {
      label: 'Data Nascimento',
      name: 'dataNascimento',
      filter: 'aluno.dataNascimento',
      func: (objColuna, objLinha) => <> {objColuna}{objLinha.tratamentoDataNascimento && objLinha.tratamentoDataNascimento.dataSubstituida ?
        <span style={{
          display: "block",
          fontSize: 11,
          color: "#999"
        }}>{objLinha.tratamentoDataNascimento.dataSubstituida}</span> : ""}</>,
      key: false
    },
    {
      label: 'Tipo', name: 'tratamentoDataNascimento', func: (objColuna, objLinha) => <> {
        objLinha.tratamentoDataNascimento ?
          objLinha.tratamentoDataNascimento.tipoLabel === "Nota" ?
            <>
              {objLinha.tratamentoDataNascimento.tipoLabel}
            </>
            : objLinha.tratamentoDataNascimento.tipoLabel
          : ""}</>, key: false
    },
    {
      label: 'Origem do Problema',
      name: 'tipoTratamentoOrigem',
      filter: 'tratamentoNome.origemProblema',
      func: (objColuna, objLinha) => <> {objLinha.tratamentoDataNascimento ? (objLinha.tratamentoDataNascimento.origem === "OUTRO" ? <>{objLinha.tratamentoDataNascimento.origem}<span
        style={{
          display: "block",
          fontSize: 11,
          color: "#999"
        }}>{objLinha.tratamentoDataNascimento.descricaoOrigemOutro}</span></> : objLinha.tratamentoDataNascimento.origem) : "--"}</>,
      key: false
    },
    {
      label: 'Status do Tratamento',
      name: 'statusTratamentoDataNascimento',
      filter: 'tratamentoNome.status',
      func: (objColuna, objLinha) => <> {objLinha.tratamentoDataNascimento ? objLinha.tratamentoDataNascimento.statusLabel : ""}{objLinha.tratamentoDataNascimento && objLinha.tratamentoDataNascimento.responsavel ?
        <span
          style={{
            display: "block",
            color: "#999",
            fontSize: 11
          }}>{objLinha.tratamentoDataNascimento.responsavel}</span> : ""}</>,
      key: false
    },
  ];
 const cartoesTableViewRef = useRef(null);
  const atualizaFiltros = (tipo,status) => {
		if (cartoesTableViewRef.current) {
	  		cartoesTableViewRef.current.atualizarFiltrosQuantitativosDataNascimento(tipo,status);
		}
  }

  return (
    <>
      <Toast ref={toastRef}/>
      <Title>Tratamento de Data de Nascimento</Title>

      <QuantitativoTratamentoDataNascimento aoClicarEmQuantitativo={atualizaFiltros}
                                  refresh={horaUltimoRefresh}
                                  processo={processo.id}/>

      <CartoesTableView
      ref={cartoesTableViewRef}
        exibeFiltro={true}
        exibeFiltroTratamentoDataNascimeto={true}
        permiteDigitarCartao={false}
        permiteEditarCartao={false}
        permiteSubstituirCartao={false}
        permiteAnexarDigitalizacao={false}
        permiteTratarPendenciaDataNascimento={true}
        permiteDescartarCartao={false}
        permiteReetiquetar={false}
        mensagemInformativaAoDescartarCartao={"Ao descartar o cartão a pendência de data de nascimento será automaticamente atualizada para 'Resolvida'"}
        colunas={columns}
        processo={processo.id}
        somenteComTratamentoDataNascimento={true}
        filtroStatusTratamentoDataNascimento={statusSelecionado}
        filtroTipoTratamentoDataNascimento={tipoSelecionado}
        aoAtualizarStatusTratamentoDataNascimento={(cartao, cartoes, setCartoes, filtroStatus) => {

          let cartoesTemp = cartoes.map(c => {

            if (c.id === cartao.data.id) {
              if (filtroStatus !== undefined && filtroStatus !== "") {
                if (filtroStatus !== cartao.data.statusTratamentoDataNascimente) {
                  return null;
                } else {
                  return cartao.data;
                }
              } else {
                return cartao.data;
              }
            } else {
              return c;
            }

          });

          setCartoes(cartoesTemp.filter(cartao => cartao != null));

        }
        }
        motivosDescarteDisponiveis={() => {
          return [{value: 'TRATAMENTO_DATA_NASCIMENTO', label: 'Tratamento de data de Nascimento'}]
        }}
        aoDescartarCartao={(cartao) => setHoraUltimoRefresh(new Date())}
        aoRestaurarCartao={(cartao) => setHoraUltimoRefresh(new Date())}
        aoLimparFiltro={limparFiltros}/>
    </>
  );
}

export default DashboardTratamentoDataNacimento;
